export default __webpack_public_path__ + "static/media/img-2.bb238fc1.jpg";